import React from 'react';

import { clsx } from 'clsx';

import styles from './ArrowButton.scss';

type ArrowButtonProps = {
  className?: string;
  onClick: VoidFunction;
  disabled?: boolean;
};

const ArrowButton = ({ className, onClick, disabled }: ArrowButtonProps) => {
  return (
    <button
      type="button"
      className={clsx(styles.arrowButton, className)}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.iconWrapper}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <g filter="url(#filter0_b_12187_4184)">
            <circle cx="20" cy="20" r="20" fill="#343434" fillOpacity="0.6" />
          </g>
          <path
            d="M19 16L23 20.5L19 25"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <filter
              id="filter0_b_12187_4184"
              x="-8"
              y="-8"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
              <feComposite
                in2="SourceAlpha"
                operator="in"
                result="effect1_backgroundBlur_12187_4184"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_backgroundBlur_12187_4184"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </button>
  );
};

export default ArrowButton;
